import { CourseOffering } from 'app/library/course-offering/models/course-offering.model';
import { Module } from 'app/library/module/models/module.model';
import { newModule } from 'app/library/module/models/newModule';
import { PartialGradeMetrics } from 'app/library/partial-grade/models/partial-grade-metric.model';
import { IEntity } from 'app/projects/entity/src/lib/interfaces/entity.interface';
import { IGradedUnitQuery } from '../interfaces/graded-unit.query.interface';

export class GradedUnit implements IEntity {
    static label_singular = 'gradedUnit';
    static label_plural = 'gradedUnits';

    static props_to_search = ['name'];

    id: string = null;
    name: string = null;
    gradeWeight: number = null;
    sequence: number = null;
    averageScore: number = null;
    sumScore: number = null;
    module: Module = null;
    courseOffering: CourseOffering;

    status?: string = 'published'; // TODO: [NV] Should this be published? Should be null!
    metrics?: PartialGradeMetrics = null;

    constructor(query?: IGradedUnitQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.gradeWeight = query.weight;
            this.sequence = query.sequence;
            this.averageScore = query.average_score;
            this.sumScore = query.sum;
            this.module = query.module ? newModule(query.module) : null;
            this.courseOffering = query.course_offering ? new CourseOffering(query.course_offering) : null;
        }
    }
}
